import type { Patient } from "./patients.types";

type Counterparty = NonNullable<Patient["counterparties"]>[number];

export type PartnerCounterpartyResolution = {
  state: "unresolved" | "none" | "resolved" | "ambiguous";
  patientId: string | null;
};

/**
 * Resolve the partner context from the relationship projection returned by
 * the API. `partnerId` and journey preferences are deliberately not used:
 * they are legacy/display fields and cannot establish who the current
 * relationship is with.
 */
export function resolvePartnerCounterparty(
  counterparties: NonNullable<Patient["counterparties"]> | null | undefined,
): PartnerCounterpartyResolution {
  if (counterparties === undefined || counterparties === null) {
    return { state: "unresolved", patientId: null };
  }

  const partnerIds = new Set(
    counterparties
      .filter((counterparty: Counterparty) => counterparty.role === "partner")
      .map((counterparty: Counterparty) => counterparty.patientId),
  );

  if (partnerIds.size === 0) {
    return { state: "none", patientId: null };
  }

  if (partnerIds.size > 1) {
    return { state: "ambiguous", patientId: null };
  }

  const patientId = [...partnerIds][0];
  return patientId
    ? { state: "resolved", patientId }
    : { state: "unresolved", patientId: null };
}
